import actions from './constants';

export const fetchDataModelsError = (category, error) => ({
  category,
  error,
  type: actions.FETCH_DATA_MODELS_ERROR,
});

export const fetchDataModelsSuccess = (category, result) => ({
  category,
  result,
  type: actions.FETCH_DATA_MODELS_SUCCESS,
});

export const fetchDatasetDataModelError = (category, code, error) => ({
  category,
  code,
  error,
  type: actions.FETCH_DATASET_DATA_MODEL_ERROR,
});

export const fetchDatasetDataModelSuccess = (category, code, result) => ({
  category,
  code,
  result,
  type: actions.FETCH_DATASET_DATA_MODEL_SUCCESS,
});

export const updateDatasetDataModel = (dataModelCode, category, code, name) => ({
  category,
  code,
  dataModelCode,
  name,
  type: actions.UPDATE_DATASET_DATA_MODEL,
});

export const updateDatasetDataModelError = (category, code, name, error) => ({
  category,
  code,
  name,
  error,
  type: actions.UPDATE_DATASET_DATA_MODEL_ERROR,
});

export const updateDatasetDataModelSuccess = (category, code, name, result) => ({
  category,
  code,
  name,
  result,
  type: actions.UPDATE_DATASET_DATA_MODEL_SUCCESS,
});
